module.exports = require("chance");